import React from 'react';
import { Tooltip } from 'antd';
import { Backlink } from '../../types';

type Props = {
	backlink: Backlink;
};

export default function BacklinkUrlTableCell({ backlink }: Props) {
	return (
		<div className="backlink-url">
			<Tooltip title={backlink.source_title}>
				<div className="truncate">{backlink.source_title}</div>
			</Tooltip>
			<div className="truncate">
				<a href={backlink.source_url} target="_blank" rel="noopener noreferrer">
					{backlink.source_url}
				</a>
			</div>
		</div>
	);
}
